export default __webpack_public_path__ + "static/media/sedated.2b6f9149.svg";